// COMPONENTS
import * as ComponentLibrary from "@picnicmedia/masanatemples123";
// FUNCTIONS
import is_new_creative from "../../../../hooks/is_new_creative";
import { createPreviewLink } from "../functions/createPreviewLink";
// CONTEXT
import { useUserState } from "../../../../contexts/user.context";
// TYPES
import { HandlePreviewButtonProps, StudioConfig } from "../types";
// CONFIGS
import studio_config from "../../../../configs/studio.json";
import config from "../../../../configs/config";

export function PreviewButton({ isTruncated, data }: HandlePreviewButtonProps) {
  const user = useUserState();
  const isNewCreative = is_new_creative();
  const studioConfig: StudioConfig = studio_config;
  // Bring-your-own packages have no studio format entry (metadata.format is "custom"), so they can't
  // read frame-ratio dimensions from studio_config — they carry their own metadata.dimensions instead.
  // Everything else (the preview link, opening a new tab) is identical to a normal ad. Also treat an
  // unknown format as a package so we never index a missing studio format entry.
  const isPackage = data.metadata.kind === "package" || !studioConfig.formats[data.metadata.format];
  const frameRatios = isPackage ? [] : studioConfig.formats[data.metadata.format || "post"].media.frameRatios;

  const handlePreview = (e: React.MouseEvent<Element, MouseEvent> | undefined) => {
    (e?.currentTarget as HTMLButtonElement).blur();
    let adSlotWidth: number;
    let adSlotHeight: number;
    if (isPackage) {
      adSlotWidth = data.metadata.dimensions?.width || 320;
      adSlotHeight = data.metadata.dimensions?.height || 480;
    } else {
      const aspectRatio = data.metadata.aspectRatio || "picnic";
      const matchedFrameRatio = frameRatios.findIndex((frameRatio: FrameRatio) => frameRatio.name === aspectRatio);
      adSlotWidth = studioConfig.formats[data.metadata.format].media.frameRatios[matchedFrameRatio].adSlotWidth;
      adSlotHeight = studioConfig.formats[data.metadata.format].media.frameRatios[matchedFrameRatio].adSlotHeight;
    }
    const configuration = {
      analytics: { DISABLED: config.analytics.DISABLED },
      preview: { URL: config.preview.URL },
      s3: { BUCKET: config.s3.BUCKET, REGION: config.s3.REGION },
      environment: config.environment,
      adSlot: { adSlotWidth, adSlotHeight },
    };
    const previewLink = createPreviewLink(data, user, configuration);
    window.open(previewLink);
  };

  return <>{isTruncated ? <ComponentLibrary.PCIconButton icon={"eye"} title={"Preview"} utilityClasses={"b--black-20"} inlineStyles={{ height: "40px", width: "40px" }} clickHandler={handlePreview} /> : <ComponentLibrary.PCActionButton isDisabled={isNewCreative} text={"Preview"} iconLeft={"eye"} iconColor={"color-text-5"} textColor={"color-text-5"} color={""} clickHandler={handlePreview} />}</>;
}
